import { render, staticRenderFns } from "./ActivitiesTable.vue?vue&type=template&id=3c8ca180&"
import script from "./ActivitiesTable.vue?vue&type=script&lang=js&"
export * from "./ActivitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8ca180')) {
      api.createRecord('3c8ca180', component.options)
    } else {
      api.reload('3c8ca180', component.options)
    }
    module.hot.accept("./ActivitiesTable.vue?vue&type=template&id=3c8ca180&", function () {
      api.rerender('3c8ca180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/activities/ActivitiesTable.vue"
export default component.exports